import MEDIASOUP_CONFIG from '@/lib/mediasoupConfig'

export default function(roomId, peerId, forceH264 = false, forceVP9 = false) {
  let url = `${MEDIASOUP_CONFIG.protooProtocol}://${MEDIASOUP_CONFIG.protooHost}:${MEDIASOUP_CONFIG.protooPort}/?roomId=${roomId}&peerId=${peerId}`

  if (forceH264) {
    url = `${url}&forceH264=true`
  } else if (forceVP9) {
    url = `${url}&forceVP9=true`
  }

  return url
}
